import React, { useState } from 'react';
import { Menu, ClipboardList } from 'lucide-react';
import Logo from './Logo';
import PartnerSidebar from './PartnerSidebar';
import AdminSidebar from './AdminSidebar';

export default function Header({ 
  userData,
  onLogout,
  onMarginChange,
  onRechargeClick,
  onTransactionHistoryClick,
  onBookingsClick, 
  onHomeClick,
  onPartnersManagementClick,
  onRechargeRequestsClick,
  onMargeB2BControlClick
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Check if user is admin
const isAdmin = !!userData?.is_admin;


  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-40">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Logo onHomeClick={onHomeClick} logoUrl={userData?.logo_url} />
          
          <div className="flex items-center gap-4">
            {/* Bookings Button */}
            <button
              onClick={onBookingsClick}
              className="flex items-center gap-2 bg-[#2B4979] text-white px-4 py-2 rounded-lg font-semibold shadow-md hover:bg-[#1e3454] transition"
            >
              <ClipboardList size={18} />
              <span className="hidden md:inline">Réservations</span>
            </button>

            {/* Menu Button - Opens Sidebar */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="flex items-center gap-2 bg-[#FF7B47] text-white px-4 py-2 rounded-lg font-semibold shadow-md hover:bg-[#ff6a30] transition"
            >
              <Menu size={23} />
              <span className="hidden md:inline"></span>
            </button>
            <button
            onClick={() => window.toggleLanguage()}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-300 hover:border-[#FF7B47] text-sm font-semibold transition"
          >
            🌐 AR / FR
          </button>
          </div>
        </div>
      </header>

      {/* ✅ Conditional Sidebar Rendering */}
      {isAdmin ? (
        <AdminSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          userData={userData}
          onLogout={onLogout}
          onPartnersManagementClick={onPartnersManagementClick}
          onRechargeRequestsClick={onRechargeRequestsClick}
          onMargeB2BControlClick={onMargeB2BControlClick}
          onTransactionHistoryClick={onTransactionHistoryClick}
        />
      ) : (
        <PartnerSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          userData={userData}
          onLogout={onLogout}
          onMarginChange={onMarginChange}
          onRechargeClick={onRechargeClick}
          onTransactionHistoryClick={onTransactionHistoryClick}
        />
      )}
    </>
  );
}
